import React from "react";
import { styled, SxProps, Link, Card, Typography, Stack, IconButton, useTheme } from "@mui/material";
import TitleItem from "../../Lists/TitleItemList/TitleItem";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { thumbnailService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { SearchCard } from "../SearchCard/SearchCard";
import { AddOutlined, CheckOutlined, RemoveOutlined } from "@mui/icons-material";

export type ItemCollectionCardProps = {
  asset: DbAssetObjectInfos;
  className?: string;
  sx?: SxProps;
  desc?: string;

  status?: "added" | "none";
  onClickAdd: () => void;
  onClickRemove: () => void;
};

const ItemCollectionCard: React.FC<ItemCollectionCardProps> = (props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { asset, status = "none", onClickAdd, onClickRemove, ...otherProps } = props;

  const [_status, setStatus] = React.useState(status);

  const handleClickAdd = () => {
    // setStatus("just-added");
    onClickAdd();
  };

  React.useEffect(() => {
    setStatus(status);
  }, [status]);

  let _renderedStatus = <></>;
  switch (_status) {
    case "added":
      _renderedStatus = <CheckOutlined color="primary" fontSize="small" />;
      break;
    default:
      _renderedStatus = (
        <Link color={theme.palette.text.primary} underline="none">
          <AddOutlined fontSize="small" />
          {t("common:add")}
        </Link>
      );
      break;
  }

  return (
    <SearchCard
      asset={asset}
      endAdornment={_renderedStatus}
      onClick={_status === "added" ? onClickRemove : handleClickAdd}
      sx={{
        ...(_status === "added" && {
          background: theme.palette.primary.alpha,
          border: `1px solid ${theme.palette.primary.main}`,
        }),
      }}
    ></SearchCard>
    // <StyledCard variant="outlined" {...otherProps} onClick={onClickSelect}>
    //   <TitleItem size="small" title={title} desc={desc} poster={poster} sx={{ flex: 0.8 }} />
    //   {_renderedStatus}
    // </StyledCard>
  );
};

export default ItemCollectionCard;
